import config, { ProductDomains } from '../../../../../config'
import { cookieConfig } from '../../../../../config/legacy'
import CookieHelper from '@ringdna/common/app/helpers/cookie-helper'

interface ICustomIdentityRequestWrapper {
  accessToken?: string
  grantId: string
  email: string
  provider: string
  name?: string
  domain?: string
  slug?: string
}

export class CustomIdentityRequestWrapperProxy {
  private grantId: string
  private provider: string
  private email: string
  private name: string | undefined
  private domain: string | undefined

  constructor(cfg: ICustomIdentityRequestWrapper) {
    // Initialize the class
    this.grantId = cfg.grantId
    this.provider = cfg.provider
    this.name = cfg.name
    this.email = cfg.email
    this.domain = cfg.domain || config[ProductDomains.API]
  }

  async request<T = any>(args: any): Promise<T> {
    try {
      const cookieHelper = new CookieHelper(cookieConfig)

      const response = await fetch(`${this.domain}/api/v2/app/calendars/schedulingPages/proxy`, {
        method: 'POST',
        body: JSON.stringify({
          payload: args.body,
          path: args.path,
          grantId: this.grantId,
          method: args.method
        }),
        headers: {
          sessionId: cookieHelper.getSessionId(),
          ...args.headers,
          'Content-Type': 'application/json'
        }
      })

      // Check if the response is not okay (e.g., 404, 500)
      if (!response.ok) {
        console.error(`Error: ${response.status} ${response.statusText}`)
        return {
          error: `Error: ${response.status} ${response.statusText}`
        } as any
      }

      // Parse the response
      const data = await response.json()
      return [data, null] as any
    } catch (error) {
      console.error('Fetch error:', error)
      return { error: 'Error' } as any
    }
  }

  /**
   * This method returns the current user's information.
   */
  async currentUser() {
    // IMPLEMENT: Get the logged in user's ID token and return the user information. For example,
    return {
      id: this.grantId,
      email: this.email
    }
  }
}
